import React from 'react';
import { css } from '@emotion/css';
import PageContainer from '../../components/structure/PageContainer';
import CustomScrollbars from '../../components/structure/CustomScrollbars';
import { color_variants_main_bg } from '../../constants/colors';
import MigrationRunner from './components/MigrationRunner';

const ModuleMigration: React.FC = () => {
    return (
        <PageContainer>
            <div className={pageStyle}>
                <CustomScrollbars>
                    <div className={contentStyle}>
                        <MigrationRunner />
                    </div>
                </CustomScrollbars>
            </div>
        </PageContainer>
    );
};

const pageStyle = css`
    display: flex;
    flex-direction: column;
    height: 100%;
    background: ${color_variants_main_bg};
`;

const contentStyle = css`
    padding: 32px;
    max-width: 900px;
`;

export default ModuleMigration;
